<template>
  <div class="courseMarket">
    <div class="tabs_box">
      <van-tabs
        v-model="active"
        scrollspy
        :ellipsis="false"
        swipe-threshold="1"
      >
        <van-tab
          v-for="(item, index) in cateList"
          :key="index"
          :title="item.cateName"
        ></van-tab>
      </van-tabs>
    </div>

    <div class="courseList_box">
      <courseList ref="courseList" :type="1" :cateId="cateId" />
    </div>
  </div>
</template>

<script>
import { ApiCoursewareCate } from "../../api/onlineLearning.js";
import { Tab, Tabs } from "vant";
import courseList from "./components/courseList.vue";

export default {
  name: "courseMarket",
  components: {
    vanTab: Tab,
    vanTabs: Tabs,
    courseList,
  },
  data() {
    return {
      active: -1,
      cateList: [],
      cateId: null,
    };
  },
  computed: {
    isApp() {
      return this.$store.state.index.isApp;
    },
    terminal() {
      return this.$store.state.index.terminal;
    },
  },
  watch: {
    active: function (value) {
      if (value > -1) {
        this.cateId = this.cateList[value].cateId;
      }
    },
  },
  beforeRouteEnter(to, from, next) {
    if (from.path === "/onlineLearning/courseDetail") {
      uni.postMessage({
        data: {
          isBack: false,
        },
      });
    }
    next();
  },
  mounted() {
    if (localStorage.getItem("payCourseId")) {
      let courseId = localStorage.getItem("payCourseId");
      localStorage.setItem("payCourseId", "");
      this.$router.push({ path: "courseDetail", query: { id: courseId } });

      if (!(this.isApp === "true" && this.terminal != 5)) {
        // 小程序
        uni.postMessage({
          data: {
            isBack: true,
          },
        });
      }
    }

    this.requestCoursewareCate();
  },
  methods: {
    // 品类
    requestCoursewareCate() {
      ApiCoursewareCate({ showPlatform: 1 }).then((res) => {
        if (res.code === 200) {
          this.cateList = res.data;

          if (res.data.length > 0) {
            this.active = 0;
            this.cateId = res.data[0].cateId;
          }
        }
      });
    },
  },
};
</script>

<style lang="scss">
@import "../../assets/css/flexable.scss";

.courseMarket {
  width: 100%;
  .tabs_box {
    position: fixed;
    top: px2rem(100);
    left: 0;
    z-index: 1;
    width: 100%;
    padding: px2rem(20) px2rem(22) px2rem(15);
    background-color: #f4fafb;
    box-sizing: border-box;
    .van-tabs__wrap {
      width: 100%;
      height: px2rem(56);
      .van-tabs__nav {
        padding-bottom: 0;
        background-color: transparent;
        .van-tabs__line {
          display: none;
        }
        .van-tab {
          margin-right: px2rem(12);
          flex: 0 0 auto;
          height: px2rem(56);
          padding: 0 px2rem(52);
          font-size: px2rem(28);
          font-weight: bold;
          color: #1f1f1f;
          border-radius: px2rem(28);
          background-color: #e2efef;
          &.van-tab--active {
            color: #fff;
            background-color: #00cbcc;
          }
        }
      }
    }
  }

  .courseList_box {
    width: 100%;
    padding: px2rem(230) px2rem(22) 0 px2rem(22);
    box-sizing: border-box;
  }
}
</style>